// extracted by mini-css-extract-plugin
export var inline = "_w6-0";